<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-normal" (click)="updateShowSearch()">
        <i class="material-icons">search</i>
      </div>
      <div *ngIf="projectId" class="ir-btn th-btn-normal" (click)="openMenu()">
        <i class="material-icons">more_vert</i>
      </div>
    </div>
    <div class="ir-line-content">
      <span
        >{{ 'machines.machines' | translate }} <strong>({{ machines?.length || 0 }})</strong></span
      >
    </div>
  </div>
  <div class="ir-line th-header-search" *ngIf="showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-unactive">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="ir-line-content">
      <input autoFocus type="search" name="Search" placeholder="Search" [formControl]="search" focus="showSearch" />
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading && !machines.length">
    <span>{{ 'common.loading' | translate }}</span>
  </div>
  <div class="ir-section--list">
    <div class="ir-line ir-line-title">
      <div class="ir-line--right">
        <button class="ir-btn ir-btn--block ir-btn--title th-btn-action ir-txt--right" (click)="createMachine()">
          <span>{{ 'machines.create-machine' | translate }}</span>
        </button>
      </div>
      <div class="ir-line-content">
        <span>{{ 'machines.machines' | translate }}</span>
      </div>
    </div>
    <app-machines-list [machines]="machines" (toggleSelect)="openMachine($event)" (toggleScroll)="loadMore()"></app-machines-list>
  </div>
</div>
